import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
// import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModule } from 'ngx-loading';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeadNoticationDetailComponent } from './lead-notication-detail';
import { NotificationRotingModule } from './notication-detail-routing';
import { SharedModule } from '../../shared/shared.module';
import { AssignmentNotifiDetailComponent } from './assignment-notifi-detail';
@NgModule({
    imports: [
        CommonModule,
        ModalModule.forRoot(),
        NgbModule.forRoot(),
        NotificationRotingModule,
        FormsModule,
        ReactiveFormsModule,
        LoadingModule,
        SharedModule
    ],
    declarations: [LeadNoticationDetailComponent, AssignmentNotifiDetailComponent],
    entryComponents: [LeadNoticationDetailComponent, AssignmentNotifiDetailComponent],
    exports: [LeadNoticationDetailComponent, AssignmentNotifiDetailComponent]
})
export class NotificationDetailModule { }



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/views/notification-detail/notification-detail.module.ts